<template>
    <AccountSettingsShell @buttonClick="updateAccountInfo">
        <CardShell>
            <BackLinkHeading linkText="Account Settings" text="Account Info" route="/settings-mobile"/>

            <HugeSpinner v-if="loadingAccountInfo"/>
            <div v-else>
                <div>
                    <!-- name, display name -->
                    <SettingSection>
                        <LabeledControl class="w-100 pb3" label="Full Name">
                            <Textbox v-model="user.name"/>
                        </LabeledControl>
                        <LabeledControl label="Display Name" notice="Optional">
                            <div class="legal">If you're a rental company, use your company name as a display name.</div>
                            <Textbox v-model="user.display_name" class="mt1"/>
                        </LabeledControl>
                    </SettingSection>

                    <!-- email, phone, password info -->
                    <SettingSection>
                        <div :class="{ 'flex' : !smallOrLess }">
                            <LabeledControl :class="{ 'pr4' : !smallOrLess }" class="w-100 pb3" label="Email">
                                <Textbox v-model="user.email"/>
                            </LabeledControl>
                            <LabeledControl class="w-100 pb3" label="Phone Number">
                                <Textbox v-model="user.phone"/>
                            </LabeledControl>
                        </div>
                        <div :class="{ 'flex items-center' : !smallOrLess }">
                            <LabeledControl :class="{ 'pr4' : !smallOrLess }" class="pb3 pb0-ns w-100" label="Password">
                                <Textbox v-model="userInfo.password"/>
                            </LabeledControl>
                            <h6 class="w-100 yellow">Change Password</h6>
                        </div>
                    </SettingSection>
                </div>
                <!-- address info -->
                <SettingSection v-if="addresses">
                    <AddressInfo v-for="(address, index) in addresses" :key="index" :index="index" :data="address"/>
                </SettingSection>
            </div> 
        </CardShell>        
    </AccountSettingsShell>
</template>

<script>
import AccountSettingsShell from '@/components/accountSettings/shared/AccountSettingsShell.vue';
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import CardHeader from '@/components/controls/CardHeader.vue';
import LabeledControl from '@/components/controls/LabeledControl.vue';
import Textbox from '@/components/controls/Textbox.vue';
import Dropdown from '@/components/controls/Dropdown.vue';
import SettingSection from '@/components/accountSettings/shared/SettingSection.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import AddressInfo from '@/components/accountSettings/AddressInfo.vue';
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            userInfo: {
                password: 'password01'
            }
        };
    },
    components: {
        AccountSettingsShell,
        CardShell,
        BackLinkHeading,
        CardHeader,
        LabeledControl,
        Textbox,
        Dropdown,
        SettingSection,
        AddressInfo,
        HugeSpinner
    },
    computed: {
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        },
        ...mapState('accountInfo', ['addresses', 'user', 'loadingAccountInfo'])
    },
    methods: {
        ...mapActions('accountInfo', ['getAccountInfo', 'postAccountInfo']),
        updateAccountInfo() {
            this.postAccountInfo();
            // this.$router.go()
        }
    },
    created: function() {
        this.getAccountInfo();
    }
};
</script>
